<template>
  <el-row class="item-container" @click.native="click" align="middle">
    <el-col class="version-item" :span="20">
      <div class="item-date">
        {{ timeDiff }}
      </div>
      <div class="item-user">
        {{ version.user.name }}
      </div>
    </el-col>
    <el-col class="item-score" :span="4">
      <h3>{{ version.score }}%</h3>
    </el-col>
  </el-row>
</template>

<script>
import { timeDifferent } from "@/helpers/timeHelper.js"

export default {
  name: "VersionInfo",
  props: {
    version: {
      type: Object,
      default: null,
    },
  },
  computed: {
    timeDiff() {
      return timeDifferent(this.version.name)
    },
  },
  methods: {
    click(event) {
      console.log('fffff')
      event.stopPropagation()
      this.$emit("click")
    },
  },
}
</script>

<style lang="scss" scoped>
.item-container {
  border-bottom: 1px dashed lightgray;
  padding: 1rem 0.5rem;
  cursor: pointer;

}
.item-container:hover {
  background-color: whitesmoke;
}
.version-item {
  margin-bottom: 0.3rem;
}
.item-score {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}
</style>
